import { AtivoMonitoramentoDetalhado } from './ativo-monitoramento-detalhado.model copy';
import { ItemMonitoramentoDetalhado } from './item-monitoramento-detalhado.model';
import { ItemMonitoramento } from './item-monitoramento.model';

export class MicroservicoMonitoramento {

  acesso: ItemMonitoramento;
  integracao: ItemMonitoramento;

  public static getAtivo(nome: string, microservico: MicroservicoMonitoramento): AtivoMonitoramentoDetalhado {
    return new AtivoMonitoramentoDetalhado(nome, [
      new ItemMonitoramentoDetalhado('Acesso', microservico.acesso),
      new ItemMonitoramentoDetalhado('Integração', microservico.integracao)
    ]);
  }
}
